var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"add-price"},[_c('specification',{attrs:{"model_id":_vm.model_id,"is_share":_vm.is_share,"spec_design":_vm.spec_design,"factoryimg_type":_vm.factoryimg_type},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }